export default __webpack_public_path__ + "static/media/internal-block-diagram.0fbac531.png";